export const priceCardData = {
  sectionTitle:
    'Se você passar no SiSU 2025, a gente te devolve 100% do seu investimento',
  priceCards: [
    {
      theme: 'proenem-secondary',
      firstTitle: 'ENEMPRO 2025',
      benefitsSummary: 'Plataforma completa',
      strikeThroughPriceLabel: 'R$ 538,80',
      additionalStrikeThroughPriceLabel: 'por 12x sem juros de',
      mainContent: 'R$ 32,90',
      discount: 240,
      isCurrency: true,
      chipLabel: 'Plano básico',
      virtualAssistantChipLabel: 'IA',
      courseInfoLabel: 'Plano de estudos personalizado',
      hasVirtualAssistent: false,
      knowMoreLabel: 'Saiba mais',
      listContent: [
        { disabled: false, text: 'Curso atualizado para o ENEM 2025' },
        { disabled: false, text: '12 meses de acesso' },
        {
          disabled: false,
          text: '4 Redações mensais corrigidas e comentadas por professores especializados'
        },
        { disabled: false, text: '6 simulados modelo ENEM com nota TRI' },
        { disabled: false, text: 'Banco com mais de 50 mil questões' },
        {
          disabled: false,
          text: 'Listas de questões por nível de dificuldade'
        },
        {
          disabled: false,
          text: 'Gráfico de evolução de acertos de questões'
        },
        { disabled: false, text: 'Apostila da aula completa em PDF' },
        {
          disabled: false,
          text: 'Provas dos últimos 10 anos, com resolução em vídeo'
        },
        { disabled: false, text: 'Tira-dúvidas' },
        { disabled: false, text: 'Projeto extrascurriculares' },
        { disabled: true, text: 'Aulas ao vivo todos os dias' },
        { disabled: true, text: 'Curso de nivelamento' },
        {
          disabled: true,
          text: 'Raio-x dos temas mais cobrados no Enem nos últimos anos'
        },
        { disabled: true, text: 'Curso completo de Redação' },
        { disabled: true, text: 'Projeto Preparação Socioemocional' },
        { disabled: true, text: 'Assistente virtual de estudos' },
        {
          disabled: true,
          text: 'Aprofundamento de Matemática, Física, Química e Biologia'
        },
        { disabled: true, text: 'Aprofundamento de Redação' },
        { disabled: true, text: 'Curso sobre as especialidades médicas' },
        {
          disabled: true,
          text: 'Simulados semanais com boletins de desempenho'
        },
        {
          disabled: true,
          text: 'Resolução de questões de vestibulares de Medicina'
        }
      ],
      plusLink: 'https://www.proenem.com.br/#turmas',
      buttonLabel: 'Quero assinar',
      mainButtonHref:
        'https://pay.hotmart.com/W97212646E?sck=undefined|undefined|undefined|undefined|undefined&utm_source=undefined&utm_medium=undefined&utm_campaign=undefined&utm_content=undefined&utm_term=undefined&checkoutMode=10&bid=1735592729510'
    },
    {
      theme: 'proenem',
      firstTitle: 'SEMIEXTENSIVA ENEM',
      benefitsSummary: 'Plataforma completa + Aulas ao vivo',
      strikeThroughPriceLabel: 'R$ 822,80',
      additionalStrikeThroughPriceLabel: 'por 12x sem juros de',
      mainContent: 'R$ 37,90',
      discount: 49,
      chipLabel: 'MAIS ESCOLHIDO',
      virtualAssistantChipLabel: 'IA',
      courseInfoLabel: 'Plano de estudos personalizado',
      hasVirtualAssistent: false,
      knowMoreLabel: 'Saiba mais',
      listContent: [
        { disabled: false, text: 'Curso atualizado para o ENEM 2025' },
        { disabled: false, text: '12 meses de acesso' },
        { disabled: false, text: 'Aulas ao vivo todos os dias' },
        {
          disabled: false,
          text: '6 Redações mensais corrigidas e comentadas por professores especializados'
        },
        { disabled: false, text: '8 simulados modelo ENEM com nota TRI' },
        { disabled: false, text: 'Banco com mais de 50 mil questões' },
        {
          disabled: false,
          text: 'Listas de questões por nível de dificuldade'
        },
        {
          disabled: false,
          text: 'Gráfico de evolução de acertos de questões'
        },
        { disabled: false, text: 'Apostila da aula completa em PDF' },
        {
          disabled: false,
          text: 'Provas dos últimos 10 anos, com resolução em vídeo'
        },
        {
          disabled: false,
          text: 'Raio-x dos temas mais cobrados no Enem nos últimos anos'
        },
        { disabled: false, text: 'Tira-dúvidas' },
        { disabled: false, text: 'Curso de nivelamento' },
        { disabled: false, text: 'Projeto Preparação Socioemocional' },
        { disabled: false, text: 'Projeto extrascurriculares' },
        { disabled: true, text: 'Curso completo de Redação' },
        { disabled: true, text: 'Assistente virtual de estudos' },
        {
          disabled: true,
          text: 'Aprofundamento de Matemática, Física, Química e Biologia'
        },
        { disabled: true, text: 'Aprofundamento de Redação' },
        { disabled: true, text: 'Curso sobre as especialidades médicas' },
        {
          disabled: true,
          text: 'Simulados semanais com boletins de desempenho'
        },
        {
          disabled: true,
          text: 'Resolução de questões de vestibulares de Medicina'
        }
      ],
      plusLink: 'https://www.proenem.com.br/#turmas',
      buttonLabel: 'Quero assinar',
      mainButtonHref:
        'https://pay.hotmart.com/Y99453451N?sck=undefined|undefined|undefined|undefined|undefined&utm_source=undefined&utm_medium=undefined&utm_campaign=undefined&utm_content=undefined&utm_term=undefined&checkoutMode=10'
    },
    {
      theme: 'promed',
      firstTitle: 'SEMIEXTENSIVA MED',
      benefitsSummary: 'Extensiva Enem + Aprofundamentos',
      strikeThroughPriceLabel: 'R$ 1.018,80',
      additionalStrikeThroughPriceLabel: 'por 12x sem juros de',
      mainContent: 'R$ 47,90',
      discount: 46,
      chipLabel: 'FOCO EM MEDICINA',
      virtualAssistantChipLabel: 'IA',
      courseInfoLabel: 'Plano de estudos personalizado',
      hasVirtualAssistent: true,
      tooltipHelperMessage: 'Disponível a partir de fevereiro de 2025',
      knowMoreLabel: 'Saiba mais',
      listContent: [
        { disabled: false, text: 'Curso atualizado para o ENEM 2025' },
        { disabled: false, text: '12 meses de acesso' },
        { disabled: false, text: 'Aulas ao vivo todos os dias' },
        { disabled: false, text: 'Curso completo de Redação' },
        {
          disabled: false,
          text: '8 Redações mensais corrigidas e comentadas por professores especializados'
        },
        { disabled: false, text: '8 simulados modelo ENEM com nota TRI' },
        { disabled: false, text: 'Banco com mais de 50 mil questões' },
        {
          disabled: false,
          text: 'Listas de questões por nível de dificuldade'
        },
        {
          disabled: false,
          text: 'Gráfico de evolução de acertos de questões'
        },
        { disabled: false, text: 'Apostila da aula completa em PDF' },
        {
          disabled: false,
          text: 'Provas dos últimos 10 anos, com resolução em vídeo'
        },
        {
          disabled: false,
          text: 'Raio-x dos temas mais cobrados no Enem nos últimos anos'
        },
        { disabled: false, text: 'Tira-dúvidas' },
        { disabled: false, text: 'Curso de nivelamento' },
        { disabled: false, text: 'Projeto Preparação Socioemocional' },
        { disabled: false, text: 'Projeto extrascurriculares' },
        { disabled: false, text: 'Curso sobre as especialidades médicas' },
        {
          disabled: false,
          text: 'Aprofundamento de Matemática, Física, Química e Biologia'
        },
        { disabled: false, text: 'Aprofundamento de Redação' },
        {
          disabled: false,
          text: 'Simulados semanais com boletins de desempenho'
        },
        {
          disabled: false,
          text: 'Resolução de questões de vestibulares de Medicina'
        }
      ],
      plusLink: 'https://www.proenem.com.br/#turmas',
      buttonLabel: 'Quero assinar',
      mainButtonHref:
        'https://pay.hotmart.com/X99453521F?sck=undefined|undefined|undefined|undefined|undefined&utm_source=undefined&utm_medium=undefined&utm_campaign=undefined&utm_content=undefined&utm_term=undefined&checkoutMode=10'
    }
  ]
}
